<div class="modal fade" #loginModal id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <span class="close-btn-modal"  data-bs-dismiss="modal" aria-label="Close"></span>
      <div class="modal-body _modal-content">
        <h4 [innerHTML]="'SignIn' | translate"></h4>
        <form [formGroup]="loginForm" (ngSubmit)="handleLogin()">
          <div class="form-item">
            <label for="email-l">{{'EmailAddress' | translate}}</label>
            <input #emailAddress id="email-l" placeholder="{{'EmailPlaceholder' | translate}}" type="text" formControlName="email" autocomplete="on">
            <div *ngIf="loginForm.controls.email.touched && submitted">
              <div class="form-error" *ngIf="loginForm.controls.email.errors?.email" [innerHTML]="'EmailErrorValid' | translate"></div>
              <div class="form-error" *ngIf="loginForm.controls.email.errors?.required" [innerHTML]="'EmailErrorRequired' | translate"></div>
            </div>
          </div>
          <div class="form-item mb-2">
            <label for="password-l" [innerHTML]="'Password' | translate"></label>
            <input type="password" id="password-l" placeholder="{{'PasswordPlaceholder' | translate}}"  formControlName="password" autocomplete="on">
            <div *ngIf="(loginForm.controls.password.touched && submitted) || !hasValuePass">
              <div class="form-error" *ngIf="loginForm.controls.password?.errors?.required" [innerHTML]="'PasswordErrorEnter' | translate"></div>
            </div>
            <div class="form-error" *ngIf="loginForm.controls.password?.errors?.auth">{{loginForm.controls.password?.errors?.auth}}</div>
          </div>
          <a (click)="handleSwitchToForgot()" [innerHTML]="'ForgotPassword' | translate"></a>
          <p *ngIf="isActivated" class="alert alert-success border-0 mt-3" [innerHTML]="'AccountSuccessfullyActivated' | translate"></p>
          <div class="button-wrapper d-flex justify-content-center">
            <button class="w-100" type="submit">
              <app-rectangle-button [loading]="submitLoading" dark [label]=" 'SignIn' | translate "></app-rectangle-button>
            </button>
          </div>
          <div class="register-info">
            <p class="text-center">{{'NewTo' | translate}} <a (click)="handleSwitch()" [innerHTML]="'Register' | translate"></a></p>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
